import React from 'react';

import { Badge, Button } from '@ergeon/core-components';
import { ArrowTopRightOnSquareIcon } from '@ergeon/icons/hero/micro';

import { API_HOST } from '../../../../../envs';

interface LeadContextMessageProps {
  leadGid?: string | null;
  channel?: string | null;
  utmCampaign?: string | null;
  services?: string[] | null;
  isComplete?: boolean | null;
  orderId?: number | null;
  comment?: string | null;
  tags?: string[] | null;
}

export const LeadContextMessage: React.FC<LeadContextMessageProps> = ({
  leadGid,
  channel,
  utmCampaign,
  services,
  isComplete,
  orderId,
  comment,
  tags,
}) => {
  return (
    <div className="flex flex-col justify-start gap-1 w-full text-left">
      <div className="flex flex-col gap-1">{leadGid && <strong>Lead: {leadGid}</strong>}</div>

      <div className="flex flex-wrap gap-2">
        {channel && <Badge flavor="primary" value={channel} />}

        {isComplete !== null && (
          <Badge flavor={isComplete ? 'success' : 'warning'} value={isComplete ? 'Complete' : 'Incomplete'} />
        )}

        {tags && tags.length > 0 && tags.map((tag, index) => <Badge flavor="warning" key={index} value={tag} />)}
      </div>

      {comment && (
        <div className="flex flex-col gap-1 paragraph-2">
          <span className="font-semibold">Customer Request:</span>
          <span className="italic">{comment}</span>
        </div>
      )}

      {services && services.length > 0 && (
        <div className="flex flex-col gap-1 paragraph-2">
          <span className="font-semibold">Requested Services:</span>
          <div className="flex flex-wrap gap-1">
            {services.map((service, index) => (
              <span key={index}>
                {service}
                {index < services.length - 1 ? ',' : ''}
              </span>
            ))}
          </div>
        </div>
      )}

      {utmCampaign && <div className="paragraph-2">Campaign: {utmCampaign}</div>}

      {orderId && (
        <Button
          asAnchor
          flavor="regular"
          href={`${API_HOST}/public-admin/store/order/${orderId}/change/`}
          size="small"
          target="_blank"
          taste="line">
          <ArrowTopRightOnSquareIcon className="size-4 shrink-0" />
          View Order #{orderId}
        </Button>
      )}
    </div>
  );
};
